import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-Report",
  "use": "rt-portal-Report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-portal-Report\"><path d=\"M192.0512 1024h-76.8v-204.8h76.8z m179.2-307.2h-76.8v307.2h76.8z m179.2-102.4h-76.8v409.6h76.8z m179.2-102.4h-76.8v512h76.8z m179.2-102.4h-76.8v614.4h76.8zM972.8 0l-256.9728 68.864 65.3824 65.3312-269.1584 269.2096-36.1984-36.1984-54.3232-54.3232-54.3232 54.3232L51.2 683.264l54.3232 54.272 316.0064-316.0576 36.1984 36.1984L512.0512 512l54.272-54.3232 269.1584-269.1584 68.4544 68.4544L972.8 0z\" fill=\"#ffffff\" p-id=\"7366\" data-spm-anchor-id=\"a313x.search_index.0.i8.8a553a81ubUE9a\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/Report.svg
// module id = 1821
// module chunks = 137